<div class="review-body-container rounded-md">
  <h1 class="review-body-title">
    {{ 'redeem_cash_v2.review.title' | translate }}
  </h1>
  <rd-rcv2-review-breakdown
    [formData]="formData"
    [promocode]="promocode"
    [redeemCashLoyaltyProgram]="redeemCashLoyaltyProgram">
  </rd-rcv2-review-breakdown>
  <div class="review-body-information">
    <p class="helper-text">
      {{
        'redeem_cash_v2.review.helper_text'
          | translate: { processingDelay: this.processingDelay }
      }}
    </p>
    <ng-container
      *ngIf="
        shouldDisplayMembershipDetailsOnReviewPage && redeemCashMembership
      ">
      <div
        [ngSwitch]="redeemCashMembership.category"
        class="review-body-redeem-to-account">
        <rd-shared-dynamic-list
          *ngSwitchCase="LoyaltyProgramCategory.CashbackToCard"
          [items]="redeemToCardDetails"
          [ariaHidden]="true"
          [listAriaLabel]="
            'accessibility.redeem_cash_v2.review.redeem_to_card'
              | translate
                : {
                    loyaltyProgram: groupName,
                    digits: redeemCashMembership.number.substr(-4)
                  }
          "></rd-shared-dynamic-list>

        <rd-shared-dynamic-list
          *ngSwitchCase="LoyaltyProgramCategory.CashbackToAccount"
          [items]="redeemToAccountDetails"
          [ariaHidden]="true"
          [listAriaLabel]="
            'accessibility.redeem_cash_v2.review.redeem_to_account'
              | translate
                : {
                    firstName: redeemCashMembership.firstName,
                    lastName: redeemCashMembership.lastName,
                    bsbNumber: bsbNumber,
                    digits: redeemCashMembership.number
                  }
          "></rd-shared-dynamic-list>

        <rd-shared-dynamic-list
          *ngSwitchCase="LoyaltyProgramCategory.CashbackToPlatform"
          [items]="redeemToPlatformDetails"
          [ariaHidden]="true"
          [listAriaLabel]="
            'accessibility.redeem_cash_v2.review.redeem_to_platform'
              | translate
                : {
                    firstName: redeemCashMembership.firstName,
                    lastName: redeemCashMembership.lastName,
                    email: redeemCashMembership.number
                  }
          "></rd-shared-dynamic-list>
      </div>
    </ng-container>
  </div>
</div>

<div class="promocode-container" *ngIf="hasPromocode">
  <rd-promocode-ui
    [promocodeLoading]="promocodeLoading"
    [promocode]="promocode"
    [promocodeUsage]="promocodeUsage"
    [promocodeHttpError]="promocodeHttpError"
    (applyPromocode)="handleApplyPromocode($event)"></rd-promocode-ui>
</div>

<rd-rcv2-review-form
  class="review-checkboxes-container"
  [cashRedemptionLoading]="cashRedemptionLoading"
  [promocodeLoading]="promocodeLoading"
  (submitEvent)="submitCashRedemptionEvent()">
</rd-rcv2-review-form>
